exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".topic {\n  padding: 10px;\n  background-color: #fafafa;\n  font-size: 15px;\n  height: 30px;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  border-bottom: 1px;\n  border-bottom-color: lightgray;\n  border-bottom-style: solid; }\n  .topic .topic-text {\n    font-size: 50px;\n    font-size: 1.5vw;\n    white-space: nowrap; }\n    @media (max-width: 800px) {\n      .topic .topic-text {\n        font-size: 12px; } }\n    @media (min-width: 1333.33333px) {\n      .topic .topic-text {\n        font-size: 20px; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/views/topic/topic.scss
// module id = 1294
// module chunks = 0